<template>
  <div class="flag" style="height: 100%;">
    <app-base-main parentTable>
      <template #filter-group>

        <app-filter-group @query="$gjNoticeQuery" :reset="false">

          <gj-country-server-select
              v-model="filter.countryIdList"
              :width="['140px', '170px']"
          ></gj-country-server-select>

          <gj-select
              v-model="filter.importStatus"
              :options="[
                { id: 'succeed', text: '成功' },
                { id: 'failed', text: '失败' },
                { id: 'noData', text: '报表无数据' },
                { id: 'getting', text: '获取中' },
              ]"
              placeholder="状态"
              type="multi-check"
              width="140px"
          ></gj-select>

          <gj-select
              v-model="filter.reportTypeList"
              :options="[
                { id: 'marketId', text: '日期业务报告' },
                { id: 'asin', text: '子ASIN业务报告' },
                { id: 'variationAsin', text: '父ASIN业务报告' },
                { id: 'msku', text: 'MSKU业务报告' },
              ]"
              placeholder="报表类型"
              type="multi-check"
              width="140px"
          ></gj-select>

          <gj-select
              v-model="filter.operationPath"
              :options="[
                  { id: 'plug', text: '云插件任务' },
                  { id: 'manual', text: '手动导入' }
              ]"
              placeholder="操作路径"
              width="110px"
          >
          </gj-select>

<!--          <div class="flex align-center size12" style="margin-left: 14px;">数据月份:</div>-->
<!--          <gj-date-picker-->
<!--              v-model="filter.months"-->
<!--              :clearable="false"-->
<!--              type="monthrange"-->
<!--              startPlaceholder="开始月份"-->
<!--              endPlaceholder="结束月份"-->
<!--              :shortcut="null"-->
<!--              tooltip="数据月份"-->
<!--          ></gj-date-picker>-->

          <gj-select-date-picker
              type="daterange"
              v-model="filter.date"
              :options="[
                {id: '0', text: '数据日期'},
                {id: '1', text: '记录时间'},
                {id: '2', text: '更新时间'},
              ]"
          ></gj-select-date-picker>

          <gj-input
              v-model="filter.keyword"
              placeholder="输入报表名称、操作用户"
              width="200px"
          ></gj-input>

        </app-filter-group>

      </template>
      <template #operate-group>
        <gj-button type="primary" style="height: 32px;" @click="openImportmodal">导入</gj-button>
        <gj-button type="primary" :loading="retakeBatchLoading" style="height: 32px;" @click="retakeBatch()" v-if="$permission('businessReport:retrieve')">重新获取</gj-button>
        <span style="font-size: 12px;">已选择：{{ selectedRows.length }}个</span>
      </template>
      <template #tool-group>
        <gj-button style="margin: 4px 8px 0 0" @click="openLog()" v-if="$permission('businessReport:log')">查看日志</gj-button>
        <gj-tool-group
            :download="$permission('businessReport:export')"
            @clickDownload="clickDownload"
            help>
        </gj-tool-group>
      </template>
      <template #table>
        <gj-table
            ref="gjTable"
            adaptParent
            :index="false"
            :data="tableData"
            :columns="columns"
            :loading="loading"
            :pagination="pagination"
            selection
            :default-sort="{prop: 'updateTime', order: 'descending'}"
            @sort-change="$gjSortChange"
            @page-change="$gjNoticeQuery">
          <template v-slot:op="{ row }">
            <gj-upload
                v-if="row.operationPath!=='plug'"
                style="display: inline-block;margin-right: 10px;"
                text="导入"
                :showFileList="false"
                uploadBtnType="text"
                container-type="dateRangeReport"
                :row="row"
                @uploadAfter="uploadAfter"
                :validFileSize="200"
                :acceptType="[FileTypeEnum.CSV, FileTypeEnum.X_CSV, FileTypeEnum.XLS, FileTypeEnum.XLSX, FileTypeEnum.X_XLS]"
            >
            </gj-upload>
            <gj-button
                v-if="row.importStatus!=='succeed'&&row.operationPath==='plug'&&$permission('businessReport:retrieve')"
                type="text"
                :loading="row.retakeSingleLoading"
                :disabled="row.importStatus==='getting'"
                @click="retakeSingle(row)"
            >重新获取</gj-button>
            <gj-button v-if="row.importStatus==='succeed'&&$permission('businessReport:export')" type="text" :loading="row.downLoad" @click="downLoad(row)">下载</gj-button>
            <gj-button type="text" @click="openLog(row.id)" v-if="$permission('businessReport:log')">日志</gj-button>
          </template>

          <!--            <template #empty>-->
          <!--                <div v-if="!loading"-->
          <!--                     class="gj-empty__wrapper">-->
          <!--                  <gj-empty>-->
          <!--                    <template #content>-->
          <!--                      <div>123</div>-->
          <!--                      <div>321</div>-->
          <!--                    </template>-->
          <!--                  </gj-empty>-->
          <!--                </div>-->
          <!--            </template>-->

          <template #empty v-if="noData">
            <div class="gj-empty__wrapper">
              <gj-empty>
                <template #content>
                  <div class="gj-empty-description">
                    <div>暂无数据</div>
                    <div style="width: 210px;">想要统计商品流量必不可少的报表哦~</div>
                  </div>
                </template>
              </gj-empty>
              <div class="empty-text size14 color666">1、安装【积加云插件】可自动获取业务报告，请确认插件是否已安装；</div>
              <div class="empty-text size12 color666" style="padding-left: 44px">
                <gj-link href="https://chrome.google.com/webstore/search/%E7%A7%AF%E5%8A%A0%E4%BA%91%E5%8A%A9%E6%89%8B?utm_source=chrome-ntp-icon" target="_blank">谷歌应用中心</gj-link>、
                <gj-link href="https://appstore.ziniao.com/search/plugin/%E7%A7%AF%E5%8A%A0%E4%BA%91%E5%8A%A9%E6%89%8B" target="_blank">紫鸟应用中心</gj-link>
                中搜索下载安装即可
              </div>
              <div class="empty-text size14 color666" style="margin-top: 5px;">2、支持手动导入报告；</div>
            </div>
          </template>

        </gj-table>
      </template>
    </app-base-main>
  </div>
</template>

<script>
import {isMeaningfulMixin, queryMixin, selectionMixin} from "@/minxins";
import {
  businessPage,
  businessRetake,
  businessImport,
  businessDownload,
  dateRangeLogDownload,
  businessLogDownload
} from "@/api/statistics"
import {convertToDate, convertToMonth} from "@/utils/date.util.js"
import {subDays} from "date-fns";
import {mapGetters} from "vuex";
import AppLogModal from "@/views/modules/statistics/business-report/modal/log-modal.vue"
import AppAddImportModal from "@/views/modules/statistics/business-report/modal/add-import-modal.vue"
import AppCoverImportModal from "@/views/modules/statistics/date-range-report/modal/cover-import-modal.vue"
import {SET_OPEN_IMPORT} from "@/store/mutation-types";
import {FileTypeEnum} from "@/components/upload/enum";
import {exportFile} from "@/api/common";

export default {
  name: "business-report",
  mixins: [queryMixin, selectionMixin, isMeaningfulMixin],
  computed: {
    ...mapGetters(['marketOption', 'openImport']),
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 从利润报表-结算明细 点击导入跳转至此页面时，打开新增导入弹框
      if (vm.openImport) {
        vm.$store.commit(SET_OPEN_IMPORT, false)
        vm.openImportmodal()
      }
    })
  },
  created() {
    this.sort.prop = 'updateTime';
  },
  data() {
    return {
      FileTypeEnum,
      loading: false, // 加载
      retakeBatchLoading: false,
      noData:false, // 数据库中是否无数据
      tableData: [], // 表格数据
      filter: {
        countryIdList: {},// 国家、店铺
        importStatus: null,// 状态	{succeed:成功;failed:失败;noData:报表无数据;getting:获取中;}
        reportTypeList: [],// 日期业务报告    marketId    子ASIN业务报告	asin    父ASIN业务报告	variationAsin    MSKU业务报告	msku
        operationPath: null,// 操作路径 {plug:浏览器插件;manual:手动导入;}
        keyword: null,// 查询关键字：报表名称或者操作用户
        months:[],// 数据月份
        date: {
          key: '0',//查询的日期类型：0，日期范围；1，记录日期；2，更新日期
          value: []
        }
      },
      columns: [
        {id: 'marketId', header: '店铺/国家', field: 'option:marketId', width: '140px', options: () => this.marketOption},
        {id: 'reportName', header: '报表名称', field: 'reportName', minWidth: '320px'},
        {id: 'reportTypeName', header: '报表类型', field: 'reportTypeName', minWidth: '120px'},
        {id: 'recordDate', header: '数据日期', field: 'recordDate', minWidth: '140px', sortable: true},
        // {id: 'dateRange', header: '日期范围', field: 'dateRange', width: '220px'},
        {id: 'operationPathName', header: '操作路径', field: 'operationPathName', minWidth: '120px'},
        {id: 'importStatusName', header: '状态', field: 'importStatusName', minWidth: '120px'},
        {id: 'operationUser', header: '操作用户 ', field: 'operationUser', minWidth: '120px'},
        {id: 'createTime', header: '记录时间', field: 'createTime', minWidth: '160px', sortable: true},
        {id: 'updateTime', header: '更新时间', field: 'updateTime', minWidth: '160px', sortable: true},
        {id: 'op', header: '操作', field: 'slot:op', width: '180px'},
      ]
    }
  },
  filters: {
    convertToDate(val) {
      if (!val) {
        return ""
      }
      return convertToDate(new Date(val))
    }
  },
  methods: {
    clickDownload(){
      if (this.selectedRows.length === 0) {
        this.$message.warning('请先勾选')
      }else {
        businessDownload({idList:this.selectedRows.map(r => r.id)}).then(data=>{
          exportFile(`/file/attachment/download`, data)
        })
      }
    },

    // 批量重新获取
    retakeBatch() {
      let idList;
      if (this.selectedRows.length === 0) {
        this.$message.warning('请先勾选')
        return
      } else {
        // 只有失败和没数据，且路径为云插件，才能重新获取
        idList = this.selectedRows.filter(r => ['failed', 'noData'].includes(r.importStatus)&&r.operationPath==='plug').map(r => r.id);
        if (idList.length === 0) {
          this.$message.warning('至少选择一条状态为失败或无数据的云插件任务报表')
          return
        } else if (this.selectedRows.length !== idList.length) {
          this.$message.warning(`有${this.selectedRows.length - idList.length}条数据不符合重新获取要求，已自动去除`)
        }
      }
      this.retakeBatchLoading = true
      businessRetake(idList).then(res => {
        this.$message.success('已提交')
        this.$gjResetPage();
      }).complete(() => this.retakeBatchLoading = false)
    },

    // 单个重新获取
    retakeSingle(row){
      row.retakeSingleLoading = true;
      businessRetake([row.id]).then(res => {
        this.$message.success('已提交')
        this.$gjResetPage();
      }).complete(() =>  row.retakeSingleLoading = false)
    },

    // 打开导入框导入
    openImportmodal() {
      //新增导入
      // if (this.selectedRows.length === 0) {
      const modal = this.$gjCreate(AppAddImportModal, {
        on: {
          importSuccess: () => {
            modal.$gjDestroy();
          },
          import: () => {
            this.$gjResetPage();
          },
        }
      })
      // }
      //覆盖导入
      // else {
      //   //
      //   const modal = this.$gjCreate(AppCoverImportModal, {
      //     props:{
      //       tableData:this.selectedRows
      //     },
      //     on: {
      //       importFileSuccess: () => {
      //         this.$gjResetPage();
      //       },
      //       importSuccess: () => {
      //         modal.$gjDestroy();
      //       }
      //     }
      //   })
      // }
    },

    // 列单条导入
    uploadAfter(attId, data, uploadCb, row) {
      businessImport({
        attachmentId: attId,
        countryCode: row.countryCode,
        marketId: row.marketId,
        recordDate: row.recordDate,
        reportType: row.reportType
      }).then(res => {
            if (res.code !== 0) {
              this.$gjMessage.error(res.msg);
            } else {
              this.$gjMessage.success('导入成功！');
            }
          }).catch(() => {
        uploadCb('error')
      }).complete(() => this.$gjResetPage());
    },

    // 日志
    openLog(id) {
      this.$gjCreate(AppLogModal, {
        props: {
          id
        }
      })
    },

    // 查询
    async $gjQuery() {
      this.loading = true
      let params = {
        model: {
          ...this.filter,
          countryIdList: this.filter.countryIdList.countryIds || [],//国家编码集合
          marketIdList: this.filter.countryIdList.marketIds || [],//店铺id集合
          dateType: this.filter.date.key,//查询的日期类型：1，记录日期；2，更新日期
          startDate: this.filter.date.value?convertToDate(this.filter.date.value[0]):'',//开始时间
          endDate: this.filter.date.value?convertToDate(this.filter.date.value[1]):'',//结束时间
        },
        ...this.queryPagination,
        ...this.querySort
      }
      try {
        let { data, other } = await businessPage(params) || {}
        if(other){
          this.noData = true;
        }else {
          this.tableData = data.records.map(r => {
            return {
              ...r,
              retakeSingleLoading:false,
              downLoad:false
            }
          })
          this.pagination = this.getPagination(data);
        }

      } finally {
        this.loading = false
      }
    },
    downLoad(row){
      row.downLoad = true;
      businessDownload({idList:[row.id]}).then(data=>{
        exportFile(`/file/attachment/download`, data).complete(() => {row.downLoad = false;});
      }).complete(() => {row.downLoad = false;});
    }
  }
}
</script>

<style scoped lang="scss">
/deep/.gj-empty__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
/deep/.gj-empty {
  width: 200px;
  padding: 10px;
}
/deep/.gj-empty-description {
  position: relative;
  top: -10px;
  color: #C0C4CC;
}
.empty-text{
  width: 443px;
  text-align: left;
}
</style>

